import { toFormattedDate } from 'components/DateTime';
const dateOptions = {
    y: 'numeric',
    m: 'numeric',
    d: 'numeric'
};
/**
 * @function formatPlannedDateLabel
 * @since 1.0.0
 * @description Formats a deal planned date for display.
 * Returns `emptyLabel` (default: "To be confirmed") when no start date is set.
 */
export function formatPlannedDateLabel(plannedDateStart, plannedDateEnd, emptyLabel) {
    if (!plannedDateStart) {
        return emptyLabel !== null && emptyLabel !== void 0 ? emptyLabel : t('To be confirmed');
    }
    const start = toFormattedDate(plannedDateStart, dateOptions);
    if (plannedDateEnd) {
        const end = toFormattedDate(plannedDateEnd, dateOptions);
        if (end && end !== start) {
            return `${start} - ${end}`;
        }
    }
    return start;
}
/**
 * @function getDealItemDateLabel
 * @since 1.0.0
 * @description Item date if set, otherwise the deal planned date (single or range).
 */
export function getDealItemDateLabel(itemDate, plannedDateStart, plannedDateEnd) {
    if (itemDate) {
        return itemDate;
    }
    if (!plannedDateStart) {
        return null;
    }
    return formatPlannedDateLabel(plannedDateStart, plannedDateEnd);
}
/**
 * @function shouldShowDealItemDateColumn
 * @since 1.0.0
 * @description Date column is RANGE-only. Shown when editing, or when a date
 * (item or deal) can be displayed in read-only views.
 */
export function shouldShowDealItemDateColumn(options) {
    if (options.plannedDateMode !== 'RANGE') {
        return false;
    }
    if (options.editable) {
        return true;
    }
    return Boolean(options.itemDate || options.plannedDateStart);
}
